"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @param {Recover} recover A reference to the Recover class.
 * @class Authorization
 * @classdesc Authorization class for Recover api
 */
var Authorization = /** @class */ (function () {
    function Authorization(recover) {
        var _this = this;
        this.recover = recover;
        /**
         *
         *
         * @memberof Authorization
         * @return {Object} Returns a message and access to the software
         * @property {string} token Auth Token String to redirected authorization.
         * @description Returns authorization object. Includes token for future request authorization.
         */
        this.authenticate = function (token) {
            return _this.recover.request('/auth', 'POST', { token: token }, null);
        };
    }
    return Authorization;
}());
exports.default = Authorization;
